import cn from 'classnames';
import styles from './EmptyReviewBlock.module.scss';

type EmptyReviewBlockProps = {
  className?: string;
  text: string;
};

export function EmptyReviewBlock({ className, text }: EmptyReviewBlockProps) {
  const wrapperClassName = cn(styles.empty, className);

  return (
    <div className={wrapperClassName}>
      <img src="/png/fail.png" alt="empty" className={styles.emptyImg} />
      <span className={styles.emptyText}>{text}</span>
    </div>
  );
}
